// extracted by mini-css-extract-plugin
module.exports = {"heading":"StaffPickerStyle_heading__2Yeas","check_block":"StaffPickerStyle_check_block__-7KGk"};